import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import whitelogo from "../assets/imgTwo/logo-white.svg";

const ContactSection = () => (
  <section
    id="contact"
    className="bg-[#001100] text-white py-8 flex justify-center items-center text-center"
  >
    <div className="w-full p-4 space-y-8">
      <h2 className="text-4xl font-bold mb-4">
        Have questions or ready to start?
      </h2>
      <p className="text-lg md:mx-[30em]">
        Contact us today and unlock seamless financial solutions for your
        business.
      </p>
      <a href="/support" className="text-inherit no-underline">
      <button className="bg-[#07775D] flex items-center justify-center mx-auto text-white my-6 rounded-full px-8 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">
        Contact us
      </button></a>

      <div className="pt-4 w-2/3 mx-auto">
        <hr></hr>
      </div>
    </div>
  </section>
);
const Footer = () => (
  <>
    <ContactSection />
    <footer className="bg-[#001100] text-white py-8">
  <div className="container mx-auto md:px-[5em] flex flex-col md:flex-row justify-between items-center">
    <div className="space-y-8 mb-8 md:mb-0">
      <img
        src={whitelogo}
        alt="unlock possibilities"
        className="rounded-lg"
      />
      <p className="text-sm md:w-[15em]">
        Simplify Payments for Customers and Businesses.
      </p>
      <div className="flex space-x-4">
        <a href="0#"><FaFacebookSquare /></a>
        <a href="0#"><FaTwitter /></a>
        <a href="0#"><FaInstagramSquare /></a>
        <a href="0#"><FaLinkedin /></a>
      </div>
    </div>
    <div className="flex flex-col md:flex-row md:space-x-32 text-white">
      <div className="text-xs md:text-base mb-6">
        <ul className="md:space-y-4">
          <li className="text-lg md:text-xl font-semibold md:mb-8">Products</li>
          <li><a href="https://sarepay.com/" className="text-inherit no-underline">Sarepay</a></li>
          <li><a href="https://payyourpensions.com/" className="text-inherit no-underline">Pensol</a></li>
          <li>Bank360</li>
          <li><a href="https://landing-page.withoctopus.com" className="text-inherit no-underline">Octopus</a></li>
          <li><a href="https://billerhq.com/" className="text-inherit no-underline">BillerHQ</a></li>
        </ul>
      </div>
      <div className="text-xs md:text-base mb-6">
        <ul className="md:space-y-4">
          <li className="text-lg md:text-xl font-semibold md:mb-8">Company</li>
          <li><a href="/company/aboutus" className="text-inherit no-underline">About Us</a></li>
          <li><a href="/company/careers" className="text-inherit no-underline">Career</a></li>
        </ul>
      </div>
      <div className="text-xs md:text-base mb-6">
        <ul className="md:space-y-4">
          <li className="text-lg md:text-xl font-semibold md:mb-8">Support</li>
          <li><a href="/support" className="text-inherit no-underline">Contact us</a></li>
        </ul>
      </div>
      <div className="text-xs md:text-base mb-6">
        <ul className="md:space-y-4">
          <li className="text-lg md:text-xl font-semibold md:mb-8">Legal</li>
          <li><a href="/isms" className="text-inherit no-underline">ISMS policy</a></li>
          <li><a href="/fraudReporting" className="text-inherit no-underline">Fraud</a></li>
          <li><a href="/privacy" className="text-inherit no-underline">Privacy policy</a></li>
          <li><a href="/terms" className="text-inherit no-underline">Terms of service</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>

  </>
);
export default Footer;
